import { Redirect, useParams } from "wouter";
import { FileSpreadsheet } from "lucide-react";
import { CustomerEvidenceTab } from "@/components/customer-evidence-tab";
import { useCustomerEvidenceAccess } from "@/hooks/use-customer-evidence-access";
import { Skeleton } from "@/components/ui/skeleton";

export default function CustomerEvidencePage() {
  const { brandId } = useParams<{ brandId: string }>();
  const access = useCustomerEvidenceAccess(brandId);
  if (access.loading) return <div className="p-6"><Skeleton className="h-32 rounded-xl" /></div>;
  if (!access.enabled) return <Redirect to={brandId ? `/brands/${brandId}` : "/"} />;
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6 md:p-8" data-testid="customer-evidence-page">
      <div className="flex items-center gap-3">
        <div className="rounded-xl bg-primary/10 p-3 text-primary"><FileSpreadsheet className="h-5 w-5" /></div>
        <div>
          <h1 className="text-2xl font-semibold">Customer Evidence</h1>
          <p className="text-sm text-muted-foreground">Aggregate buyer evidence for persona generation and research.</p>
        </div>
      </div>
      <CustomerEvidenceTab key={brandId} brandId={brandId} />
    </div>
  );
}
